import { useEffect, useRef } from "react";
import { useAiChat } from "./useAiChat";
import { AiChatEmpty } from "./ai-chat-empty.component";
import { AiChatMessages } from "./ai-chat-messages.component";
import { AiChatInput } from "./ai-chat-input.component";
import { AiConversationSelect } from "./ai-conversation-select.component";
import { useHelpStore } from "@/lib/store/help.store";

interface AiChatTabProps {
  app: "dentlab" | "dentconnect";
  currentRoute: string;
}

export const AiChatTab: React.FC<AiChatTabProps> = ({ app, currentRoute }) => {
  const assistantPrefill = useHelpStore((state) => state.assistantPrefill);
  const prefillHandledRef = useRef<string | null>(null);

  const {
    messages,
    sendMessage,
    status,
    stop,
    conversations,
    activeConversationId,
    loadConversationMessages,
    startNewChat,
    sendWithPrefill,
  } = useAiChat({ app, currentRoute });

  const isStreaming = status === "streaming" || status === "submitted";

  useEffect(() => {
    if (
      assistantPrefill &&
      assistantPrefill !== prefillHandledRef.current &&
      messages.length === 0 &&
      !isStreaming
    ) {
      prefillHandledRef.current = assistantPrefill;
      sendWithPrefill(assistantPrefill);
    }
  }, [assistantPrefill, messages.length, isStreaming, sendWithPrefill]);

  const handleSend = (text: string) => {
    sendMessage({ parts: [{ type: "text", text }] });
  };

  return (
    <div className="flex flex-col h-full">
      <AiConversationSelect
        conversations={conversations}
        activeConversationId={activeConversationId}
        onSelect={loadConversationMessages}
        onNew={startNewChat}
      />
      <div className="flex-1 flex flex-col overflow-hidden">
        {messages.length === 0 && !isStreaming ? (
          <AiChatEmpty />
        ) : (
          <AiChatMessages messages={messages} isStreaming={isStreaming} />
        )}
      </div>
      <AiChatInput onSend={handleSend} onStop={stop} isStreaming={isStreaming} />
    </div>
  );
};
